const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"35b97e8f5c24ad45a90b70841aa1f27253c6e8f3"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["necktip-test@mangoweb"]={id:"35b97e8f5c24ad45a90b70841aa1f27253c6e8f3"};
      